import { Children, useEffect, useState } from 'react';
import { VfModal } from '@vfit/shared/components';
import { LinkWithIcon, CustomText } from '@vfit/shared/atoms';
import { IModalInfo, INextSteps } from '@vfit/shared/models';
import {
  Container,
  Title,
  StepsList,
  Step,
  NumberBox,
  Description,
  LinkContainer,
  ModalInfoContainer,
  FirstContent,
  SecondContent,
} from './nextSteps.style';

const NextSteps: React.FC<INextSteps> = ({ dataSteps, trackOrder }) => {
  const [modalConfig, setModalConfig] = useState<{
    ctaLabel: string;
    title: string;
    firstContent: string;
    secondContent?: string;
    isOpen: boolean;
  }>({
    ctaLabel: '',
    title: '',
    firstContent: '',
    secondContent: '',
    isOpen: false,
  });
  const { title, nextSteps } = dataSteps;

  const toggleModal = (modalDetail?: IModalInfo) => {
    setModalConfig({
      ctaLabel: modalDetail?.ctaLabel || '',
      title: modalDetail?.title || '',
      firstContent: modalDetail?.firstContent || '',
      secondContent: modalDetail?.secondContent || '',
      isOpen: true,
    });
  };

  const handleClose = () => {
    setModalConfig({
      ctaLabel: '',
      title: '',
      firstContent: '',
      secondContent: '',
      isOpen: false,
    });
  };

  const checkTrackOrder = () => {
    const trackingElement = document.getElementById('tracking');
    if (trackingElement && trackOrder?.link) {
      trackingElement.style.cursor = 'pointer';
      trackingElement.addEventListener('click', () => {
        window.open(trackOrder.link, '_blank');
      });
    }
  };

  useEffect(() => {
    checkTrackOrder();
  }, []);

  return (
    <>
      <Container>
        <Title>{title}</Title>
        <StepsList>
          {Children.toArray(
            nextSteps?.map((step, index) => (
              <Step>
                <NumberBox>{index + 1}</NumberBox>
                <Description>
                  <CustomText text={step?.description} />
                  {step?.moreInfo && !!step?.moreInfo?.ctaLabel && (
                    <LinkContainer>
                      <LinkWithIcon
                        onClick={() => toggleModal(step?.moreInfo)}
                        text={step?.moreInfo?.ctaLabel}
                      />
                    </LinkContainer>
                  )}
                </Description>
              </Step>
            ))
          )}
        </StepsList>
        {dataSteps.modalTitle && (
          <LinkContainer>
            <LinkWithIcon
              onClick={() => {
                toggleModal({
                  ctaLabel: dataSteps?.modalTitle || '',
                  title: dataSteps?.modalTitle || '',
                  firstContent: dataSteps.modalDescription || '',
                });
              }}
              text={dataSteps.modalTitle}
            />
          </LinkContainer>
        )}
      </Container>
      <VfModal isOpen={modalConfig.isOpen} handleClose={handleClose}>
        <ModalInfoContainer>
          <Title>{modalConfig?.title}</Title>
          <FirstContent>
            <CustomText text={modalConfig?.firstContent} />
          </FirstContent>
          {modalConfig?.secondContent && (
            <SecondContent>
              <CustomText text={modalConfig?.secondContent} />
            </SecondContent>
          )}
        </ModalInfoContainer>
      </VfModal>
    </>
  );
};
export default NextSteps;
